import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * システムの現在バージョンのフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const CurrentSystemVersionFormBase: FC<Props> = ({ register }) => (
  <Input
    id="currentSystemVersion"
    type="text"
    {...register('currentSystemVersion')}
    disabled
  />
);
